
import debounce from 'lodash/debounce'
import 'components/treeview-check.tag'
riot.tag2('catalog-tree-check', '  <div class="row panel-option" if="{!hidePanel}">\n    <div class="col-md-8 col-sm-6 col-xs-12">\n      <div class="form-inline m-b-2">\n        <button class="btn btn-primary" if="{opts.add}" onclick="{opts.add}" type="button"><i class="fa fa-plus"></i> Добавить</button>\n        <button class="btn btn-success" if="{opts.reload}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n        <button class="btn btn-danger" if="{opts.remove &amp;&amp; selectedCount}" onclick="{remove}" title="Удалить" type="button"><i class="fa fa-trash">{(selectedCount > 1) ? ⁗&nbsp;⁗ : ⁗⁗}</i><span class="badge" if="{selectedCount &gt; 1}">{selectedCount}</span></button>\n        <yield from="head"></yield>\n      </div>\n    </div>\n    <div class="col-md-4 col-sm-6 col-xs-12">\n      <form class="form-inline text-right m-b-2">\n        <div class="form-group">\n          <div class="input-group" if="{opts.search}">\n            <input class="form-control" name="search" type="text" placeholder="Поиск" onkeyup="{find}"><span class="input-group-btn">\n              <button class="btn btn-default" onclick="{find}" type="submit"><i class="fa fa-search"></i></button></span>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <treeview-check nodes="{nodes}" handlers="{opts.handlers}" label-field="{opts.labelField}" children-field="{opts.childrenField}" loader="{loader}" descendants="{opts.descendants}" dblclick="{opts.dblclick}">\n        <yield to="before">\n          <yield from="before"></yield>\n        </yield>\n        <yield to="after">\n          <yield from="after"></yield>\n        </yield>\n      </treeview-check>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var _this2 = this;

var self = this;

self.mixin('permissions');
self.nodes = [];
self.selectedCount = 0;
self.handlers = opts.handlers;

self.reload = function () {
    self.trigger('reload');
    self.loader = true;
    self.update();

    var params = {};
    params.isTree = true;

    if (opts.search && self.search) {
        params.searchText = self.search.value;
    }

    API.request({
        object: opts.object,
        method: 'Fetch',
        data: params,
        success: function success(response) {
            self.nodes = response.items;
        },
        complete: function complete() {
            self.loader = false;
            self.update();
        }
    });
};
self.getSelectedNodes = function (e) {
    return self.tags['treeview-check'].getSelectedNodes();
};
self.remove = function (e) {
    var _this = _this2;

    var items = self.tags['treeview-check'].getSelectedNodes();
    var itemsToRemove = items.map(function (i) {
        return i.id;
    });

    if (opts.remove) opts.remove.bind(_this2, e, itemsToRemove, self)();
};

self.afterRemove = function () {
    self.tags.treeview.removeNodes();
    self.update();
};

self.find = debounce(function (e) {
    self.reload();
}, 400);

self.on('mount', function () {
    self.reload();
});

self.on('update', function () {
    if (opts.hidePanel) {
        self.hidePanel = opts.hidePanel;
    } else {
        self.hidePanel = true;
    }
    self.handlers = opts.handlers;
});

self.one('updated', function () {
    self.tags['treeview-check'].on('nodeselect', function (item, count) {
        self.selectedCount = count;
        self.update();
    });
});
});


// WEBPACK FOOTER //
// ./components/catalog-tree-check.tag